import { makeStyles } from '@mui/styles';
import { LoginRootBackground } from '../../../assets/assetSelector';

const loginStyles = makeStyles((theme) => {
  return {
    root: {
      minHeight: `calc(100vh - ${theme.config.isTopNavbarFixed ? '0px' : '96px'})`,
      paddingTop: theme.config.isTopNavbarFixed ? '96px' : '0px',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      backgroundColor: [1].includes(theme.config.themeNumber) ? theme.palette.primary.main : null,
      backgroundImage: [1].includes(theme.config.themeNumber) ? null : `url(${LoginRootBackground()})`,
      backgroundSize: [1].includes(theme.config.themeNumber) ? null : 'cover',
      backgroundRepeat: [1].includes(theme.config.themeNumber) ? null : 'no-repeat',
      backgroundPosition: [1].includes(theme.config.themeNumber) ? null : 'center',
      backgroundAttachment: [1].includes(theme.config.themeNumber) ? null : 'fixed',
      [theme.breakpoints.up('md')]: {
        justifyContent: theme.config.isLoginAdEnabled ? 'right' : 'center',
      },
    },
    loginCard: {
      margin: theme.spacing(3),
      minheight: '50vh',
      width: '95%',
      [theme.breakpoints.up('sm')]: {
        width: '450px',
      },
      [theme.breakpoints.up('md')]: {
        marginLeft: theme.config.isLoginAdEnabled ? `calc((50vw - 450px)/2)` : theme.spacing(3),
        marginRight: theme.config.isLoginAdEnabled ? `calc((50vw - 450px)/2)` : theme.spacing(3),
      },
      background: theme.palette.specifics.loginCard,
      position: 'relative',
      color: theme.palette.primary.dark,
      '& a': {
        textDecoration: 'none',
        fontWeight: '600',
      },
    },
    loginCardTitle: {
      color: theme.palette.specifics.loginCardTitleColor || theme.palette.primary.main,
    },
    loginCardHeaderSubheader: {
      fontStyle: 'italic',
      fontSize: 14,
      color: theme.palette.specifics.loginCardHeaderSubheaderColor || '',
    },
    loginTabs: { backgroundColor: theme.palette.specifics.loginTab || 'lightgrey' },
    loginTypeTab: {
      minWidth: 0,
    },
    carousel: {
      width: '50vw',
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: theme.config.isLoginAdEnabled ? 'block' : 'none',
      },
    },
    carouselImage: {
      width: '50vw',
    },
    backdrop: {
      zIndex: 1,
      color: theme.palette.primary.dark,
    },
    grow: {
      flexGrow: 1,
    },
  };
});

export default loginStyles;
